export enum VerificationTransactionScoreTypes {
    ASSERTION_SCORE = 'Assertion Score',
    IDW_TRUST_SCORE = 'IDW Trust Score',
    IDW_RISK_SCORE = 'IDW Risk Score',
    TMX_SCORE = "TMX Score",
    RAW_ASSERTION_SCORE = "Raw Assertion Score"
}